<div class="w-100 h-100 d-flex align-items-center justify-content-center flex-column">
    <div *ngIf="loading" id="loader-wrapper" style="position: relative;">
        <div id="loader"><div></div><div></div><div></div><div></div><div></div></div>
    </div>
    <ng-container *ngIf="!loading">
        <div *ngIf="!url">{{ 'APP.DOWNLOADS.FILE_NOT_FOUND' | translate }}</div>
        <div *ngIf="url" class="mt-3">{{ 'APP.DOWNLOADS.IF_DOWNLOAD_NOT_STARTED' | translate }}<a class="text-primary" style="cursor: pointer;" (click)="onClick()">{{ 'APP.DOWNLOADS.CLICK_HERE' | translate }}</a></div>    
    </ng-container>
</div>